import React from 'react';
import { ArrowRight, CheckCircle, Award } from 'lucide-react';

const HeroSophisticated = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-slate-900 via-green-900 to-emerald-950">
      <div className="absolute inset-0">
        <div className="absolute inset-0 opacity-20" style={{backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='grid' width='60' height='60' patternUnits='userSpaceOnUse'%3E%3Cpath d='M 10 0 L 0 0 0 10' fill='none' stroke='rgba(255,255,255,0.05)' stroke-width='1'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='100%25' height='100%25' fill='url(%23grid)'/%3E%3C/svg%3E")`}}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-3 px-5 py-2 bg-gradient-to-r from-amber-500/20 to-amber-600/20 backdrop-blur-sm rounded-full border border-amber-500/30 mb-8">
              <Award className="text-amber-400" size={20} />
              <span className="text-amber-200 font-medium text-sm tracking-wide">NPOP CERTIFIED • ORGANIC EXPORTER</span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-serif mb-6 leading-tight">
              <span className="text-white font-light">Exquisite</span>
              <span className="block text-amber-400 font-semibold mt-2">Organic Products</span>
              <span className="block text-emerald-300 text-4xl sm:text-5xl font-light mt-2">from the Heart of India</span>
            </h1>

            <p className="text-xl text-slate-300 mb-8 leading-relaxed font-light">
              Sustainably sourced, meticulously processed, and internationally certified. 
              Experience the purity of India's organic heritage.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <a
                href="#products"
                className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-lg font-medium text-lg shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
              >
                Discover Our Range
                <ArrowRight className="ml-2" size={20} />
              </a>
              <a
                href="#contact"
                className="inline-flex items-center justify-center px-8 py-4 bg-transparent border border-amber-400/50 text-amber-200 rounded-lg font-medium text-lg hover:bg-amber-400/10 transition-all duration-300"
              >
                Partner With Us
              </a>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/10">
              {[
                { label: 'Farm Sourced', icon: CheckCircle },
                { label: 'NPOP Certified', icon: Award },
                { label: 'Global Export', icon: CheckCircle }
              ].map((item, index) => (
                <div key={index} className="text-center">
                  <item.icon className="text-emerald-400 mx-auto mb-2" size={24} />
                  <p className="text-slate-400 text-sm">{item.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {[
              { 
                name: 'Turmeric',
                desc: 'Powder & Flakes',
                gradient: 'from-yellow-600/20 to-orange-600/20',
                border: 'border-yellow-500/30'
              },
              { 
                name: 'Ginger',
                desc: 'Powder & Flakes',
                gradient: 'from-orange-600/20 to-amber-600/20',
                border: 'border-orange-500/30'
              },
              { 
                name: 'Buckwheat',
                desc: 'Premium Quality',
                gradient: 'from-amber-700/20 to-yellow-700/20',
                border: 'border-amber-500/30'
              },
              { 
                name: 'Black Cardamom',
                desc: 'Aromatic Spice',
                gradient: 'from-green-700/20 to-emerald-700/20',
                border: 'border-green-500/30'
              }
            ].map((product, index) => (
              <div
                key={index}
                className={`relative bg-gradient-to-br ${product.gradient} backdrop-blur-md border ${product.border} rounded-2xl p-6 hover:scale-105 transition-all duration-300 group`}
              >
                <div className="absolute top-3 right-3">
                  <CheckCircle className="text-emerald-400 opacity-70" size={20} />
                </div>
                <h3 className="text-white font-semibold text-xl mb-1">{product.name}</h3>
                <p className="text-slate-400 text-sm">{product.desc}</p>
                <div className="mt-4 text-amber-400 text-xs font-medium tracking-wide">NPOP CERTIFIED</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute top-1/4 left-0 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl"></div>
    </section>
  );
};

export default HeroSophisticated;